module.exports = "/_next/static/images/dummy-pdf-2374e4792eb4c7bc775b53261da1cbae.svg";